import sqftShapeManager from "../store/sqftShapeManager";
import workspace from "./workspace";
import config from "../store/sqftConfig";
import store from "../../../../../store";
import $ from "jquery";
import sqftShape from "./shapes/sqftShape";
import {getMidPoint} from "../../../helpers/sqftHelper";
import slabWorkspace from "./slab/slabWorkspace";
import {BACKSPLASH_LABELS, EDGE_LABELS, SQFT_FEATURES} from "../../../constants";
import {getShapesCenterPoint} from "../../../helpers/conflictPopupHelper";
import {getControllersResources} from "../store/workspaceControllers";
import {HIGHLIGHT_LINE_RESOURCE} from "../../../config/featureConstants";
import {getViewportSize} from "../store/canvasHelper";

const workspaceZoom = function () {
  this.zoomToFeature = (sqftFeature) => {
    let shape = sqftShapeManager.getShapeById(sqftFeature.sqftId);
    if (shape && shape.part === 'line') {
      const line = workspace.getLineById(shape.attachedToId);
      this.zoomToLine(line);

      return;
    }

    if (!(shape instanceof(sqftShape))) {
      return
    }

    this.zoomToShape(shape);
  }
  this.zoomToFeatures = (sqftFeature, highlightColor = 'active') => {
    if (Array.isArray(sqftFeature.sqftIds) && sqftFeature.sqftIds.length > 0) {
      const shapeIds = sqftFeature.sqftIds;
      //Zoom to center of all shapes
      this.zoomToShapes(shapeIds);

      //Highlight shapes and lines
      const shapesAndAttachedResources = workspace.getShapes().filter(shape => shapeIds.includes(shape.id));
      for (const shape of shapesAndAttachedResources) {
        const partIdsThatCanBeHighlighted = [
          ...Object.keys(EDGE_LABELS),
          ...Object.keys(BACKSPLASH_LABELS),
          SQFT_FEATURES.crown_molding,
          SQFT_FEATURES.handle,
          SQFT_FEATURES.hinge
        ];

        if (shape instanceof sqftShape) {
          shape.shapeRender.blink.start({ blinkMs: 1400, totalMs: 5000, colorOverride: highlightColor });
        } else if (partIdsThatCanBeHighlighted.includes(shape.partId)) {
          const line = workspace.getLineById(shape.id);
          if (line) {
            line.blink.start({ blinkMs: 1400, totalMs: 5000, colorOverride: highlightColor});
          }
        }
      }

      //highlight features from controllers
      const controllerResources = getControllersResources(shapeIds);
      for (const controllerResource of controllerResources) {
        if (HIGHLIGHT_LINE_RESOURCE.includes(controllerResource.partId)) {
          const line = workspace.getLineById(controllerResource.lineId);
          if (line) {
            line.blink.start({ blinkMs: 1400, totalMs: 5000, colorOverride: highlightColor});
          }
        } else if (SQFT_FEATURES.hinge === controllerResource.partId) {
          const shape = workspace.getShapeById(controllerResource.shapeId);
          if (shape) {
            const lines = shape.getLines();
            for (const line of lines) {
              if (line.isWithHandle()) {
                line.blink.start({ blinkMs: 1400, totalMs: 5000, colorOverride: highlightColor});
              }
            }
          }
        }
      }
    }
  }

  this.zoomToLine = (line) => {
    let shape = line.getParent();
    let shapePos = shape.getPosition();
    const scale = config.scale;
    const { canvasWidth, canvasHeight } = getViewportSize();

    const sqftPoup = $(".sqft-popupv2");
    const popUpWidth = sqftPoup[0] ? sqftPoup[0].offsetWidth : 0;

    const midPoint = getMidPoint(line.from, line.to);

    let newWorkspacePos = {
      x: (shapePos.x + midPoint.x) * scale - (canvasWidth - popUpWidth) / 2,
      y: (shapePos.y + midPoint.y) * scale - canvasHeight / 2,
    }

    line.blink.start();
    this.zoomTo(newWorkspacePos);
  }

  this.getShapeCenter = (shape, isHalfScreen) => {
    const shapePos = shape.getPosition();
    const shapeMinMax = sqftShapeManager.getMinMax(shape.getLines());
    const scale = config.scale;
    const sqftPoup = $(".sqft-popupv2");
    const state = store.getState();
    const {sqftFeaturesPopup} = state.sqftState;
    const popUpWidth = sqftPoup[0] && sqftFeaturesPopup.opened ? sqftPoup[0].offsetWidth : 0;
    const windowWidth = window.outerWidth;
    const { canvasWidth, canvasHeight } = getViewportSize();

    let newWorkspacePos = {
      x: shapePos.x * scale + shapeMinMax.width / 2 * scale - (canvasWidth - popUpWidth) / 2,
      y: shapePos.y * scale + shapeMinMax.height / 2 * scale - canvasHeight / 2,
    }

    if (isHalfScreen) {
      newWorkspacePos.x = newWorkspacePos.x + canvasWidth / 4;
    }

    // console.log("getShapeCenter------------------------", );
    // console.log("popUpWidth", popUpWidth);
    // console.log("scale", scale);
    // console.log("shapePos", shapePos);
    // console.log("shapeMinMax", shapeMinMax);
    // console.log("canvas.width", canvas.width);
    // console.log("canvas.height", canvas.height);
     console.log("canvasWidth", canvasWidth);
     console.log("windowWidth", windowWidth);
    // console.log("newWorkspacePos", newWorkspacePos);
    // console.log("getShapeCenter------------------------", );

    return newWorkspacePos
  }

  this.zoomToShape = (shape, isHalfScreen = false, timeout = 1) => {
    const newWorkspacePos = this.getShapeCenter(shape, isHalfScreen);
    this.zoomTo(newWorkspacePos, timeout);
    shape.shapeRender.blink.start();
  }

  this.zoomToShapes = (shapeIds) => {
    const centerPoint = getShapesCenterPoint(shapeIds);
    if (centerPoint) {
      this.zoomTo(centerPoint, 0.1);
    }
  }

  this.zoomToSlabShape = (shape, isHalfScreen = false) => {
    let shapePos = shape.getPosition();
    const shapePosSlab = shape.getSlabPosition();
    const shapePosRegular = shape.getRegularPosition();
    const posDiff = {x: shapePosSlab.x - shapePosRegular.x, y: shapePosSlab.y - shapePosRegular.y}
    const workspacePos = workspace.getPosition();
    const shapeMinMax = sqftShapeManager.getMinMax(shape.getLines());
    const scale = config.scale;
    const { canvasWidth, canvasHeight } = getViewportSize();

    let newWorkspacePos = {
      x: shapePos.x * scale + shapeMinMax.width / 2 * scale - workspacePos.x - posDiff.x * scale,
      y: shapePos.y * scale - canvasHeight / 2 + shapeMinMax.height / 2 * scale - workspacePos.y - posDiff.y * scale,
    }
    if (isHalfScreen) {
      newWorkspacePos.x = newWorkspacePos.x - canvasWidth / 4;
    }

    this.zoomToInSlab(newWorkspacePos);
  }

  this.zoomTo = (newWorkspacePos, timeout = 1) => {
    let workspacePos = workspace.getPosition();
    let isXIncrementUp = newWorkspacePos.x >= workspacePos.x;
    let isYIncrementUp = newWorkspacePos.y >= workspacePos.y;

    let updateWorkspacePos = () => {
      if (Math.ceil(workspacePos.x) === Math.ceil(newWorkspacePos.x)
        && Math.ceil( workspacePos.y) === Math.ceil(newWorkspacePos.y)
      ) {
        clearInterval(refreshIntervalId);
      }

      let incrementX = Math.abs((Math.abs(newWorkspacePos.x) + Math.abs(workspacePos.x)) / newWorkspacePos.x * config.zoomSpeed);
      let incrementY = Math.abs((Math.abs(newWorkspacePos.y) + Math.abs(workspacePos.y)) / newWorkspacePos.y * config.zoomSpeed);

      workspacePos = {
        x: isXIncrementUp
          ? workspacePos.x >= newWorkspacePos.x ? newWorkspacePos.x : workspacePos.x + incrementX
          : workspacePos.x <= newWorkspacePos.x ? newWorkspacePos.x : workspacePos.x - incrementX,
        y: isYIncrementUp
          ? workspacePos.y >= newWorkspacePos.y ? newWorkspacePos.y : workspacePos.y + incrementY
          : workspacePos.y <= newWorkspacePos.y ? newWorkspacePos.y : workspacePos.y - incrementY,
      }

      workspace.setPosition(workspacePos);
    };
    let refreshIntervalId = setInterval(updateWorkspacePos, timeout);
  }

  this.zoomToInSlab = (newWorkspacePos) => {
    let workspacePos = slabWorkspace.getPos();
    let isXIncrementUp = newWorkspacePos.x >= workspacePos.x;
    let isYIncrementUp = newWorkspacePos.y >= workspacePos.y;

    let updateWorkspacePos = () => {
      if (Math.ceil(workspacePos.x) === Math.ceil(newWorkspacePos.x)
        && Math.ceil( workspacePos.y) === Math.ceil(newWorkspacePos.y)
      ) {
        clearInterval(refreshIntervalId);
      }

      let incrementX = Math.abs((Math.abs(newWorkspacePos.x) + Math.abs(workspacePos.x)) / newWorkspacePos.x * config.zoomSpeed);
      let incrementY = Math.abs((Math.abs(newWorkspacePos.y) + Math.abs(workspacePos.y)) / newWorkspacePos.y * config.zoomSpeed);

      workspacePos = {
        x: isXIncrementUp
          ? workspacePos.x >= newWorkspacePos.x ? newWorkspacePos.x : workspacePos.x + incrementX
          : workspacePos.x <= newWorkspacePos.x ? newWorkspacePos.x : workspacePos.x - incrementX,
        y: isYIncrementUp
          ? workspacePos.y >= newWorkspacePos.y ? newWorkspacePos.y : workspacePos.y + incrementY
          : workspacePos.y <= newWorkspacePos.y ? newWorkspacePos.y : workspacePos.y - incrementY,
      }

      slabWorkspace.setPos(workspacePos);
    };
    let refreshIntervalId = setInterval(updateWorkspacePos, 1);
  }
};

export default new workspaceZoom
